import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { FboEntity } from './fbo.model';

export enum FboActionTypes {
  LoadFbos = '[Fbo] Load Fbos',
  AddFbo = '[Fbo] Add Fbo',
  UpsertFbo = '[Fbo] Upsert Fbo',
  AddFbos = '[Fbo] Add Fbos',
  UpsertFbos = '[Fbo] Upsert Fbos',
  UpdateFbo = '[Fbo] Update Fbo',
  UpdateFbos = '[Fbo] Update Fbos',
  DeleteFbo = '[Fbo] Delete Fbo',
  DeleteFbos = '[Fbo] Delete Fbos',
  ClearFbos = '[Fbo] Clear Fbos',
}

export class LoadFbos implements Action {
  public readonly type = FboActionTypes.LoadFbos;

  constructor(public payload: { fbos: FboEntity[] }) {}
}

export class AddFbo implements Action {
  public readonly type = FboActionTypes.AddFbo;

  constructor(public payload: { fbo: FboEntity }) {}
}

export class UpsertFbo implements Action {
  public readonly type = FboActionTypes.UpsertFbo;

  constructor(public payload: { fbo: FboEntity }) {}
}

export class AddFbos implements Action {
  public readonly type = FboActionTypes.AddFbos;

  constructor(public payload: { fbos: FboEntity[] }) {}
}

export class UpsertFbos implements Action {
  public readonly type = FboActionTypes.UpsertFbos;

  constructor(public payload: { fbos: FboEntity[] }) {}
}

export class UpdateFbo implements Action {
  public readonly type = FboActionTypes.UpdateFbo;

  constructor(public payload: { fbo: Update<FboEntity> }) {}
}

export class UpdateFbos implements Action {
  public readonly type = FboActionTypes.UpdateFbos;

  constructor(public payload: { fbos: Update<FboEntity>[] }) {}
}

export class DeleteFbo implements Action {
  public readonly type = FboActionTypes.DeleteFbo;

  constructor(public payload: { id: string }) {}
}

export class DeleteFbos implements Action {
  public readonly type = FboActionTypes.DeleteFbos;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearFbos implements Action {
  public readonly type = FboActionTypes.ClearFbos;
}

export type FboActions =
  | LoadFbos
  | AddFbo
  | UpsertFbo
  | AddFbos
  | UpsertFbos
  | UpdateFbo
  | UpdateFbos
  | DeleteFbo
  | DeleteFbos
  | ClearFbos;
